import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { ClientService } from '../../data-access/client.service';
import { Subject, takeUntil } from 'rxjs';
import { FormGroup, FormControl, Validators, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Client } from '../../interfaces/client.interface';

@Component({
  standalone: true,
  imports: [
    ReactiveFormsModule,
    CommonModule,
    FormsModule],
  providers: [
    ClientService
  ],
  selector: 'equine-ui-nx-client-admin',
  templateUrl: './client-admin.component.html',
  styleUrls: ['./client-admin.component.css']
})
export class ClientAdminComponent implements OnInit, OnDestroy {

  #clientService = inject(ClientService);
  unsubscribe$ = new Subject<void>();
  id = '';
  form: FormGroup;
  clients: Client[] = [];
  showClients: boolean = false;

  constructor() {
    this.form = new FormGroup({
      name: new FormControl('', Validators.required),
      description: new FormControl(''),
    });
  }

  createNew() {
    if (this.form.valid) {
      this.#clientService.create(this.form.value)
        .pipe(
          takeUntil(this.unsubscribe$)
        )
        .subscribe({
          next: (response) => {
            this.id = response.id;
            if (this.showClients) {
              this.fetchClients();
            }
          }
        });
    }
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  ngOnInit() {
    this.fetchClients();
  }

  fetchClients() {
    this.#clientService.getAll()
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe({
      next: (clients) => this.clients = clients
    });
  }

  toggleShowClients() {
    this.showClients = !this.showClients;
    if (this.showClients) {
      this.fetchClients();
    }
  }

  editClient(client: Client) {
    client.isEditing = true
  }

  cancelEditing(client: Client) {
    client.isEditing = false;
  }

  updateClient(client: Client) {
    if (!client.isEditing) return;
    const updatedClient = {
      name: client.name,
      description: client.description
    };
    this.#clientService.update(client.id, updatedClient)
      .subscribe({
        next: () => {
          client.isEditing = false;
          this.fetchClients();
        }
      });
  }

  deleteClient(id: string) {
    this.#clientService.delete(id).subscribe(() => {
      this.fetchClients();
    });
  }

}
